import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-grow: 1;\n\n  & > * {\n    flex-grow: 1;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  align-self: start;\n\n  display: flex;\n  flex-direction: column;\n  gap: var(", ");\n  flex-grow: 1;\n\n  padding-inline-start: var(", ");\n  padding-top: var(", ");\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  grid-row: 1;\n  grid-column: 2;\n\n  align-self: center;\n  justify-self: center;\n\n  box-sizing: border-box;\n\n  width: 6px;\n  height: 6px;\n\n  margin-inline-end: ", ";\n\n  border: solid 1px var(", ");\n  border-radius: 50%;\n\n  transition-timing-function: var(", ");\n  transition-duration: ", ", ", ";\n  transition-property: transform, opacity;\n\n  pointer-events: none;\n\n  ", ":disabled ~ & {\n    opacity: 0;\n  }\n\n  ", "[aria-checked='true'] ~ & {\n    transform: translateX(", ");\n    opacity: 0;\n  }\n\n  [dir='rtl'] ", "[aria-checked='true'] ~ & {\n    transform: translateX(", ");\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  grid-row: 1;\n  grid-column: 1;\n\n  align-self: center;\n  justify-self: center;\n\n  margin-inline-start: ", ";\n\n  width: 1px;\n  height: 8px;\n\n  background: var(", ");\n\n  transition-timing-function: var(", ");\n  transition-duration: ", ", ", ";\n  transition-property: transform, opacity;\n\n  ", ":disabled ~ & {\n    opacity: 0;\n  }\n\n  pointer-events: none;\n\n  ", "[aria-checked='false'] ~ & {\n    transform: translateX(", ");\n    opacity: 0;\n  }\n\n  [dir='rtl'] ", "[aria-checked='false'] ~ & {\n    transform: translateX(", ");\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  grid-row: 1;\n  grid-column: 1 / 3;\n\n  pointer-events: none;\n\n  &::after {\n    position: absolute;\n\n    top: ", ";\n\n    width: ", ";\n    height: ", ";\n\n    background-color: var(", ");\n\n    border-radius: 50%;\n    transform-origin: center;\n\n    transition-timing-function: var(", ");\n    transition-duration: ", ";\n    transition-property: left, transform, translate, scale;\n\n    content: '';\n  }\n\n  ", ":disabled ~ & {\n    opacity: 0.7;\n  }\n\n  /**\n   * This is the fallback for browsers not supporting dedicated transform\n   * properties\n   */\n  @supports not ((translate: 0px) or (scale: 1)) {\n    ", "[aria-checked='false'] ~ &::after,\n  [dir='rtl'] ", "[aria-checked='true'] ~ &::after {\n      left: ", ";\n    }\n\n    ", "[aria-checked='true'] ~ &::after,\n  [dir='rtl'] ", "[aria-checked='false'] ~ &::after {\n      left: ", ";\n    }\n\n    ", ":not(:disabled):hover ~ &::after {\n      transform: scale(", ");\n    }\n  }\n\n  /**\n   * This takes advantage of the new dedicated transform properties and is a\n   * future proof solution. Even though it was primarely introduced to fix a bug\n   * in iOS 15, where transition had no effect on 'left' property\n   */\n  @supports (translate: 0px) or (scale: 1) {\n    ", "[aria-checked='false'] ~ &::after,\n    [dir='rtl'] ", "[aria-checked='true'] ~ &::after {\n      translate: ", " 0;\n    }\n\n    ", "[aria-checked='true'] ~ &::after,\n    [dir='rtl'] ", "[aria-checked='false'] ~ &::after {\n      translate: ", " 0;\n    }\n\n    ", ":not(:disabled):hover ~ &::after {\n      scale: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  grid-row: 1;\n  grid-column: 1 / 3;\n\n  margin: 0;\n  padding: 0;\n\n  background-color: var(\n    ", "\n  );\n\n  border: none;\n\n  border-radius: ", ";\n  outline-offset: var(", ");\n\n  cursor: pointer;\n\n  transition-timing-function: var(", ");\n  transition-duration: ", ";\n  transition-property: background-color;\n\n  appearance: none;\n  -webkit-tap-highlight-color: transparent;\n\n  &:hover {\n    background-color: var(\n      ", "\n    );\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n\n  &[aria-checked='true'] {\n    background-color: var(", ");\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: grid;\n  flex-shrink: 0;\n  grid-template-columns: repeat(2, 1fr);\n\n  box-sizing: border-box;\n\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  display: flex;\n  align-items: flex-start;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing'; // All values are pixel values, units are omitted for calculations.

var containerWidth = 58;
var containerHeight = 32;
var containerPadding = 3;
var switchIdleSize = 26;
var switchHoverSize = 20;
var switchHoverScaleFactor = switchHoverSize / switchIdleSize;
var hoverEffectDuration = '150ms';
var toggleEffectDuration = '250ms';
export var StyledContainer = styled.div(_templateObject(), injectSpacing('margin'));
export var StyledToggleContainer = styled.span(_templateObject2(), containerWidth + 'px', containerHeight + 'px');
export var StyledToggleButton = styled.button(_templateObject3(), function (props) {
  return props.theme.colors.interaction.tertiary.default;
}, containerHeight / 2 + 'px', function (props) {
  return props.theme.responsive.spacing.xxs;
}, function (props) {
  return props.theme.easing;
}, toggleEffectDuration, function (props) {
  return props.theme.colors.interaction.tertiary.hover;
}, function (props) {
  return props.theme.colors.ui.success;
});
export var StyledToggleSwitch = styled.div(_templateObject4(), containerPadding + 'px', switchIdleSize + 'px', switchIdleSize + 'px', function (props) {
  return props.theme.colors.base.grey[0];
}, function (props) {
  return props.theme.easing;
}, toggleEffectDuration, StyledToggleButton, StyledToggleButton, StyledToggleButton, containerPadding + 'px', StyledToggleButton, StyledToggleButton, containerWidth - switchIdleSize - containerPadding + 'px', StyledToggleButton, switchHoverScaleFactor, StyledToggleButton, StyledToggleButton, containerPadding + 'px', StyledToggleButton, StyledToggleButton, containerWidth - switchIdleSize - containerPadding + 'px', StyledToggleButton, switchHoverScaleFactor);
export var StyledOnIndicator = styled.div(_templateObject5(), containerPadding + 'px', function (props) {
  return props.theme.colors.base.grey[0];
}, function (props) {
  return props.theme.easing;
}, toggleEffectDuration, hoverEffectDuration, StyledToggleButton, StyledToggleButton, switchIdleSize + 'px', StyledToggleButton, switchIdleSize * -1 + 'px');
export var StyledOffIndicator = styled.div(_templateObject6(), containerPadding + 'px', function (props) {
  return props.theme.colors.ui.tertiary;
}, function (props) {
  return props.theme.easing;
}, toggleEffectDuration, hoverEffectDuration, StyledToggleButton, StyledToggleButton, switchIdleSize * -1 + 'px', StyledToggleButton, switchIdleSize + 'px');
export var StyledLabelContainer = styled.div(_templateObject7(), function (props) {
  return props.theme.responsive.spacing.s;
}, function (props) {
  return props.theme.responsive.spacing.s;
}, function (props) {
  return props.theme.responsive.spacing.xxs;
});
export var StyledFormLabelContainer = styled.div(_templateObject8());